import React from "react";

// IMAGE IMPORTS
import blog08 from "../../../images/blog/blog6.jpg";
import { Link } from "react-router-dom";
import CommentForm from "../CommentForm";
import RelatedBlog from "../RelatedBlog";
import ItemDetailsContent from "./ItemDetailsContent";
const Marketing: React.FC = () => {
  return (
    <section className="blog_details_section pt-70">
      <div className="container">

        {/* MAIN IMAGE */}
        <div className="single-item-image mb-70">
          <img src={blog08} alt="Blog" />
        </div>

        {/* HEADER META */}
        <ItemDetailsContent />

        {/* CONTENT ROW */}
        <div className="row mt-none-30 g-0 align-items-center">
          <div className="col-lg-12  container">

            <div className="blog_details_content">

              {/* AUDIO BUTTON */}
              {/* <div className="post_audio">
                <button className="audio_play_btn xb-border" type="button">
                  <i className="fas fa-play"></i>
                  <span className="time">6:24</span>
                  <span>Listen to this article!</span>
                </button>
              </div> */}

              {/* MAIN HEADING */}
              <h3 className="item_details_info_heading mb-35">
                Smarter marketing powered by AI and data intelligence.
              </h3>

              {/* <div className="row mb-35 mt-none-30">
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog09} alt="Blog" />
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 mt-30">
                  <div className="single-item-image">
                    <img src={blog10} alt="Blog" />
                  </div>
                </div>
              </div> */}

              <p>
               At our AI SaaS and data solutions company, we design AI-driven marketing platforms that help businesses transform data into strategic advantage. By analyzing customer behavior, predicting trends, and optimizing campaigns, our solutions enable brands to make smarter, faster, and more profitable marketing decisions.
              </p>

              <p className="mt-20">
               We work closely with businesses to align AI marketing tools with their goals whether it’s increasing conversions, improving engagement, or enhancing customer loyalty. Our platforms integrate seamlessly with existing marketing stacks, allowing teams to harness AI intelligence without disrupting ongoing campaigns.
              </p>
              {/* VIDEO EMBED */}
              <div className="row mb-45 align-items-center mt-60">
                <div className="col-md-6 mt-30">
              <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/3MwMII8n1qM?si=0ICgv9m3WV0OsHJ6" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
                </div>

                <div className="col-md-6 mt-30">
                  <ul className="iconlist_block">
                    <li><span className="iconlist_text">Predictive Analytics.</span></li>
                    <li><span className="iconlist_text">Audience Segmentation.</span></li>
                    <li><span className="iconlist_text">Personalized Campaigns.</span></li>
                    <li><span className="iconlist_text">Performance Optimization.</span></li>
                    <li><span className="iconlist_text">Cross-Channel Integration.</span></li>
                    <li><span className="iconlist_text">Real-Time Insights.</span></li>
                  </ul>
                </div>
              </div>

              <h3 className="item_details_info_heading mb-20 mt-60">
               Turning Marketing Data into Actionable Insights
              </h3>

              <p className="mb-40">
               AI marketing goes beyond traditional analytics. It identifies patterns in customer behavior, predicts which strategies will succeed, and automatically optimizes campaigns for maximum impact. By continuously learning from new data, AI ensures that marketing efforts remain relevant, personalized, and efficient.<br></br>
              From email and social media campaigns to paid advertising and content personalization, AI-powered marketing helps businesses stay ahead in a crowded and fast-moving landscape.
              </p>
              

              {/* IMAGE + LIST */}
             

              <h3 className="item_details_info_heading mb-25">3 Ways AI Marketing Drives Business Growth</h3>

              <ul className="iconlist_block numlist_block list-unstyled">
                <li><span className="iconlist_text">1. Smarter Targeting.</span></li>
                <li><span className="iconlist_text">2. Increased Efficiency.</span></li>
                <li><span className="iconlist_text">3. Better ROI & Engagement.</span></li>
              </ul>

              {/* AUTHOR BLOCK */}
              {/* <div className="post-block-wrap mb-50">
                <div className="postabmin_block xb-border ul_li">

                  <div className="admin_image">
                    <img src={avatar1} alt="Author" />
                  </div>

                  <div className="admin_content">
                    <h4 className="admin_name">Aiden Brooks</h4>
                    <span className="admin_designation">Content Manager</span>
                    <p>A content editor plays a pivotal role in shaping and refining digital content...</p>

                    <ul className="social_icons_blocks list-unstyled ul_li">
                      <li><Link to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                      <li><Link to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    </ul>
                  </div>

                </div>
              </div> */}

              {/* TAGS + SOCIAL */}
              <div className="row mt-none-30">
                {/* <div className="col-md-6 mt-30">
                  <ul className="tags_block list-unstyled">
                    <li><Link className="xb-border" to="/blog-details">AI Solutions</Link></li>
                    <li><Link className="xb-border" to="/blog-details">Data Science</Link></li>
                    <li><Link className="xb-border" to="/blog-details">SaaS</Link></li>
                  </ul>
                </div> */}

                {/* <div className="col-md-6 mt-30">
                  <ul className="social_icons_block list-unstyled ul_li justify-content-md-end">
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-facebook-f"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-twitter"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-linkedin-in"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fab fa-instagram"></i></Link></li>
                    <li><Link className="xb-border" to="/blog-details"><i className="fas fa-share-alt"></i></Link></li>
                  </ul>
                </div> */}
              </div>

              {/* COMMENTS AREA */}
              {/* <CommentsArea /> */}

              {/* COMMENT FORM */}
              <CommentForm />

              {/* SUBSCRIBE BOX */}
              {/* <NewsletterBox /> */}
            </div>
          </div>
          {/* <BlogSidebar /> */}
        </div>

        <RelatedBlog/>

      </div>
    </section>
  );
};

export default Marketing;
